import { useState, useEffect } from 'react';
import { getMapVisibilityFeature, updateMapVisibilityFeature } from '../services/api';

export const useMapVisibilityFeature = () => {
  const [featureData, setFeatureData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState(false);

  const fetchFeatureData = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getMapVisibilityFeature();
      setFeatureData(data);
    } catch (err) {
      setError(err.response?.data?.msg || err.message || 'Error al cargar la configuración');
    } finally {
      setLoading(false);
    }
  };

  const updateFeature = async (enabled, description = '') => {
    try {
      setUpdating(true);
      setError(null);
      const data = await updateMapVisibilityFeature({ enabled, description });
      setFeatureData(data);
      return data;
    } catch (err) {
      const errorMessage = err.response?.data?.msg || err.message || 'Error al actualizar la configuración';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    fetchFeatureData();
  }, []);

  return {
    featureData,
    loading,
    error,
    updating,
    updateFeature,
    refetch: fetchFeatureData
  };
};
